@if (universalService.userLoggedIn) {
  <div class="banner" id="bannerContent">
    @for (bnr of bannersArray; track bnr) {
      <div class="bannersData mt-1 mb-2">
        @if (bnr.showBanner) {
          <div class="banner-content {{bnr.bannerClassName}}">
            <div class="left-content">
              <span class="banner-icon {{bnr.bannerIconType}}"></span>
              <span class="banner-text">{{bnr.bannerTxt}}</span>
            </div>
            <div class="right-content">
              @if (bnr.bannerBtn != '') {
                <button class="banner-button" (click)="redirectUser(bnr)">{{bnr.bannerBtn}}</button>
              }
              @if (bnr.showCloseButton) {
                <span class="banner-close Neueclosefilled" (click)="closeBanner(bnr)" title="Close"></span>
              }
            </div>
          </div>
        }
        <!-- <div class="banner-empty-space">
      </div> -->
    </div>
  }
</div>
}